export function buildBannerPathname({
  query,
  facetId,
}: {
  query: Record<string, string | string[] | undefined>;
  facetId?: string[];
}) {
  const { sortBy, page } = query;

  const facetIdString = facetId ? encodeURIComponent(facetId.join("/")) : "";
  const pageString = `${facetIdString ? "/" : ""}page/${page}`;
  const sortByString = sortBy
    ? `${facetIdString || pageString ? "/" : ""}sortBy/${sortBy}`
    : "";

  return `${facetIdString}${pageString}${sortByString}`;
}
